import { render, staticRenderFns } from "./scope-list.vue?vue&type=template&id=51be4cbb&scoped=true&"
import script from "./js/scope-list.js?vue&type=script&lang=js&"
export * from "./js/scope-list.js?vue&type=script&lang=js&"
import style0 from "./scope-list.vue?vue&type=style&index=0&id=51be4cbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be4cbb",
  null
  
)

export default component.exports